define(() => {

    return ['TranslateService', function (TranslateService) {

        //service interface
        return {
            /**
             * Creates artifitial modelView with list of values for Female, Male and Company selection.
             * On Contact type change (Person to Company and via versa), it resets to null irrelevant fields to selected Contact type
             * e.g. if Contact became Company, service resets fields relevant to Person: dateOfBirth, gender, nationality, etc
             */
            createContactTypeGenderModelView: createContactTypeGenderModelView,
        };

        //service internals
        function createContactTypeGenderModelView(_contactView) {

                let isCompany = _contactView.isCompany.value,
                    gender = _contactView.gender.value,
                    contactView = _contactView;

                if ((isCompany === 'true' || isCompany === true) &&
                    !(gender === undefined || gender === null)) {
                    throw new Error('ContactTypeGender cannot have input IsCompany=true and defined Gender');
                }

                let selectedValue = null;
                if (isCompany === 'true' || isCompany === true) {
                    selectedValue = 'company';
                } else if (gender === 'F') {
                    selectedValue = 'female';
                } else if (gender === 'M') {
                    selectedValue = 'male';
                } else {
                    selectedValue = undefined;
                }

                function onContactTypeSelection(oldType, newType) {
                    if (newType === 'company') {
                        contactView.isCompany.value = true;
                        contactView.gender.value = null;
                        contactView.nationality.value = null;
                        contactView.dateOfBirth.value = null;
                    } else if (newType === null || newType === undefined) {
                        contactView.gender.value = null;
                        contactView.isCompany.value = null;
                        contactView.nationality.value = null;
                        contactView.dateOfBirth.value = null;
                    } else if (newType === 'female' || newType === 'male') {
                        contactView.isCompany.value = false;
                        if (newType === 'female') {
                            contactView.gender.value = 'F';
                        } else {
                            contactView.gender.value = 'M';
                        }
                    }
                }

                const contactTypeGender = {
                    get value() {
                        return selectedValue;
                    },
                    set value(newValue) {
                        switch (newValue) {
                            case 'female':
                            case 'male':
                            case 'company':
                            case undefined:
                            case null:
                                onContactTypeSelection(selectedValue, newValue);
                                selectedValue = newValue;
                                break;
                            default:
                                throw new Error(`Illegal value: ${newValue}`);
                        }
                    },
                    get isSelected() {
                        return selectedValue !== undefined && selectedValue !== null;
                    },
                    get isPerson() {
                        return selectedValue === 'female' || selectedValue === 'male' ||
                            contactView.isCompany.value === false; //case, when not a company, but gender not yet selected
                    },
                    get isCompany() {
                        return selectedValue === 'company';
                    },
                    options: [
                        {
                            get code() {
                                return 'female';
                            },
                            get name() {
                                return TranslateService.instant('typekey.GenderType.F');
                            },
                        },
                        {
                            get code() {
                                return 'male';
                            },
                            get name() {
                                return TranslateService.instant('typekey.GenderType.M');
                            },
                        },
                        {
                            get code() {
                                return 'company';
                            },
                            get name() {
                                return TranslateService.instant('typekey.Contact.Company');
                            },
                        },
                    ],
                };

                return Object.seal(contactTypeGender);
            } //end of function

    }]; //end of service def

});


// WEBPACK FOOTER //
// ../common/js/src/edge/quoteandbind/baslercommon/services/BaslerContactTypeGenderSelector.js